import React from "react";
import {faClipboardList} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-light-svg-icons";
import {IWeekCard} from "../interfaces/IWeekCard";
import {useHistory} from "react-router-dom";


function WeekCard(p: IWeekCard) {
    let history = useHistory();
    return(
        <div className={'week-card'}>
            <img src={p.backgroundImage} alt=""/>
            <div className={'trans-container'}>

            </div>
            <div className={'week-no'}>
                {(p.isLock) ? <FontAwesomeIcon className={'icon'} icon={faLock}/> : '' }
                <div>{p.weekNo} {p.isLock}</div>
                <span>
                        {p.lockDetail}
                    </span>
            </div>
            <div className={'progress-percentage'}>
                {p.progressLabel}
            </div>
            <div className={'week-title'}>
                {p.weekTitle}
            </div>
            <div className={'tasks'}>
                <div>
                    <FontAwesomeIcon className={'icon'} icon={faClipboardList}/>
                </div>
                <div className={'count'}>
                    {p.taskLabel}
                </div>
            </div>

        </div>
    )
}

export default WeekCard;